export default __webpack_public_path__ + "static/banner-4be8480302fe4e339585c2b56577f731.png";